if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      this.slidingSearchOverlay = document.getElementById('sliding-search-overlay');
      this.searchToggle = document.querySelector('.thb-search--toggle');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
            this.closeSlidingSearch();
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sliding Search Functionality
      if (this.searchToggle && this.slidingSearchOverlay) {
        this.searchToggle.addEventListener('click', (e) => {
          e.preventDefault();
          this.openSlidingSearch();
        });

        const closeButton = this.slidingSearchOverlay.querySelector('.sliding-search-close');
        if (closeButton) {
          closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeSlidingSearch();
          });
        }

        // Close on overlay click
        this.slidingSearchOverlay.addEventListener('click', (e) => {
          if (e.target === this.slidingSearchOverlay) {
            this.closeSlidingSearch();
          }
        });

        // Close on click capture element
        const clickCapture = document.querySelector('.searchform--click-capture');
        if (clickCapture) {
          clickCapture.addEventListener('click', (e) => {
            this.closeSlidingSearch();
          });
        }
      }

      // Desktop header search input functionality
      const headerSearchInput = document.getElementById('header-search-input');
      if (headerSearchInput && this.slidingSearchOverlay) {
        // Show sliding search overlay when header search input is clicked or focused on desktop
        const handleDesktopSearch = (e) => {
          if (window.innerWidth >= 768) { // Desktop only
            e.preventDefault();
            e.stopPropagation();
            this.openSlidingSearch();
          }
        };

        headerSearchInput.addEventListener('click', handleDesktopSearch);
        headerSearchInput.addEventListener('focus', handleDesktopSearch);

        // Prevent form submission on desktop when input is clicked
        const headerSearchForm = headerSearchInput.closest('form');
        if (headerSearchForm) {
          headerSearchForm.addEventListener('submit', (e) => {
            if (window.innerWidth >= 768 && this.slidingSearchOverlay.classList.contains('active')) {
              e.preventDefault();
              e.stopPropagation();
            }
          });
        }

        // Handle window resize to update functionality
        window.addEventListener('resize', debounce(() => {
          // Re-attach event listeners after resize to ensure proper functionality
          headerSearchInput.removeEventListener('click', handleDesktopSearch);
          headerSearchInput.removeEventListener('focus', handleDesktopSearch);
          headerSearchInput.addEventListener('click', handleDesktopSearch);
          headerSearchInput.addEventListener('focus', handleDesktopSearch);
        }, 100));
      }

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    openSlidingSearch() {
      if (this.slidingSearchOverlay) {
        this.slidingSearchOverlay.classList.add('active');
        document.body.classList.add('overflow-hidden');
        
        // Initialize search functionality
        this.initSearchFunctionality();
        
        // Focus on search input after animation
        setTimeout(() => {
          const searchInput = this.slidingSearchOverlay.querySelector('#sliding-search-input');
          if (searchInput) {
            searchInput.focus();
          }
        }, 300);
      }
    }

    closeSlidingSearch() {
      if (this.slidingSearchOverlay) {
        this.slidingSearchOverlay.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('open-search');
        // Reset search state
        this.resetSearchState();
      }
    }

    resetSearchState() {
      const searchInput = this.slidingSearchOverlay.querySelector('#sliding-search-input');
      const popularSearches = this.slidingSearchOverlay.querySelector('#popular-searches');
      const predictiveSearch = this.slidingSearchOverlay.querySelector('#sliding-predictive-search');
      
      if (searchInput) {
        searchInput.value = '';
      }
      
      if (popularSearches && popularSearches.children.length > 0) {
        popularSearches.style.display = 'block';
      }
      
      if (predictiveSearch) {
        predictiveSearch.setAttribute('inert', '');
      }
    }

    initSearchFunctionality() {
      const searchInput = this.slidingSearchOverlay.querySelector('#sliding-search-input');
      const popularSearchItems = this.slidingSearchOverlay.querySelectorAll('.popular-search-item');
      const popularSearches = this.slidingSearchOverlay.querySelector('#popular-searches');
      const predictiveSearch = this.slidingSearchOverlay.querySelector('#sliding-predictive-search');
      
      if (searchInput) {
        // Handle input changes
        searchInput.addEventListener('input', (e) => {
          const query = e.target.value.trim();
          
          if (query.length > 0) {
            // Show predictive search, hide popular searches
            if (popularSearches) popularSearches.style.display = 'none';
            if (predictiveSearch) {
              predictiveSearch.removeAttribute('inert');
              this.getPredictiveSearchResults(query, predictiveSearch);
            }
          } else {
            // Show popular searches, hide predictive search
            if (popularSearches && popularSearches.children.length > 0) {
              popularSearches.style.display = 'block';
            }
            if (predictiveSearch) {
              predictiveSearch.setAttribute('inert', '');
            }
          }
        });

        // Handle form submission
        searchInput.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const form = searchInput.closest('form');
            if (form) {
              form.submit();
            }
          }
        });
      }

      // Handle popular search clicks
      if (popularSearchItems) {
        popularSearchItems.forEach(item => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            const searchTerm = item.getAttribute('data-search');
            if (searchInput && searchTerm) {
              searchInput.value = searchTerm;
              searchInput.focus();
              
              // Trigger input event to show predictive search
              const inputEvent = new Event('input', { bubbles: true });
              searchInput.dispatchEvent(inputEvent);
            }
          });
        });
      }
    }

    async getPredictiveSearchResults(query, predictiveSearchElement) {
      if (!predictiveSearchElement) return;
      
      const container = predictiveSearchElement.querySelector('.thb-predictive-search--container');
      const loadingOverlay = predictiveSearchElement.querySelector('.loading-overlay');
      
      // Show loading state
      predictiveSearchElement.classList.add('loading');
      
      try {
        // Use the existing predictive search endpoint
        const response = await fetch(`${window.location.origin}/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,article,query,collection&resources[limit]=10&section_id=predictive-search`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const resultsSection = doc.querySelector('#shopify-section-predictive-search');
        
        if (resultsSection) {
          const resultsMarkup = resultsSection.innerHTML;
          container.innerHTML = resultsMarkup;
        } else {
          container.innerHTML = '<div class="thb-predictive-search--content"><p>No results found</p></div>';
        }
        
      } catch (error) {
        console.error('Error fetching predictive search results:', error);
        container.innerHTML = '<div class="thb-predictive-search--content"><p>Error loading search results</p></div>';
      } finally {
        predictiveSearchElement.classList.remove('loading');
      }
    }

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
      this.submenus = this.querySelectorAll('.thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu');
    }

    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;

      // Resize on initial load
      document.fonts.ready.then(() => {
        window.addEventListener('resize', debounce(() => {
          _this.resizeSubMenus();
        }, 100));
      });
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        const subSubmenus = submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu');

        subSubmenus.forEach((subSubmenu) => {
          const submenuRect = subSubmenu.getBoundingClientRect();
          const submenuRightEdge = submenuRect.left + submenuRect.width;
          const submenuIsOverflowing = submenuRightEdge > window.innerWidth;

          if (submenuIsOverflowing) {
            subSubmenu.parentElement.classList.add('left-submenu');
          } else {
            subSubmenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }

  customElements.define('full-menu', FullMenu);
}
